import React from 'react';

import { AlertDialog } from '@rbilabs/universal-components';
import { isString } from 'lodash-es';

import useEffectOnce from 'hooks/use-effect-once';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import type { IAlertDialogEventLogger } from './types';

// A wrapper for the `AlertDialog` component to log the mParticle event.
export const AlertDialogEventLogger = ({
  /**
   * A small string sent to mParticle describing the purpose of the modal.
   */
  modalAppearanceEventMessage,
  /**
   * The string to sent to mParticle describing modal header/title.
   */
  modalAppearanceHeader,
  /**
   * The string to sent to mParticle describing modal message.
   */
  modalAppearanceMessage,
  /**
   * Additional Error details to be sent to mParticle.
   */
  errorEventMessage,
  ...props
}: IAlertDialogEventLogger) => {
  const { logEvent } = useMParticleContext();

  useEffectOnce(() => {
    logEvent(CustomEventNames.MODAL_APPEARANCE, EventTypes.Other, {
      Message: modalAppearanceEventMessage,
      ErrorMessage: errorEventMessage,
      ModalHeader: isString(modalAppearanceHeader) ? modalAppearanceHeader : '',
      ModalMessage: isString(modalAppearanceMessage) ? modalAppearanceMessage : '',
    });
  });

  return <AlertDialog {...props} />;
};
